import { productCardType } from '@/commonTypes';

export interface GroupedAttribute {
  attributeId: number;
  attributeName: string;
  attributeSlug: string;
  values: string[];
}

export const getGroupedAttributes = (product?: productCardType | null): GroupedAttribute[] => {
  return Object.values(
    (product?.attributes ?? []).reduce<Record<string, GroupedAttribute>>((acc, item) => {
      const key = item.attributeSlug;

      if (!acc[key]) {
        acc[key] = {
          attributeId: item.attributeId,
          attributeName: item.attributeName,
          attributeSlug: item.attributeSlug,
          values: [],
        };
      }

      if (item.value) {
        acc[key].values.push(item.value);
      }

      return acc;
    }, {}),
  );
};
